export { default } from './label';